export const PENDING_MEDICATION_CHANGE = 'PENDING_MEDICATION_CHANGE';

export default function changePendingMedication(actualPendingApplications) {
  return {
    type: PENDING_MEDICATION_CHANGE,
    payload: {
      actualPendingApplications,
    },
  };
}
